var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.shaqFAQ)?_c('div',[_c('h1',[_vm._v(_vm._s(_vm.shaqFAQ.question))]),_c('br'),_c('h1',[_vm._v(_vm._s(_vm.shaqFAQ.answer))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }